import { ComponentProps, CSSProperties } from 'react';
import { Toaster as Sonner } from 'sonner';
import { useThemeStore } from '@/Domain/store/theme.store';

type ToasterProps = ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme } = useThemeStore();

  return (
    <Sonner
      className="toaster group"
      theme={theme as ToasterProps['theme']}
      richColors
      expand
      visibleToasts={3}
      gap={12}
      style={
        {
          '--border-radius': '0.75rem',
          '--normal-bg': 'var(--card)',
          '--normal-border': 'var(--border)',
          '--normal-text': 'var(--card-foreground)',
          '--success-bg': 'var(--success-muted)',
          '--success-border': 'var(--success-muted)',
          '--success-text': 'var(--foreground)',
          '--error-bg': 'var(--destructive-muted)',
          '--error-border': 'var(--destructive-muted)',
          '--error-text': 'var(--foreground)',
          '--warning-bg': 'var(--warning-muted)',
          '--warning-border': 'var(--warning-muted)',
          '--warning-text': 'var(--foreground)',
          '--info-bg': 'var(--info-muted)',
          '--info-border': 'var(--info-muted)',
          '--info-text': 'var(--foreground)',
        } as CSSProperties
      }
      toastOptions={{
        classNames: {
          toast: 'shadow-lg',
          content: 'gap-3',
          title: 'text-sm font-medium',
          description: 'text-sm',
          icon: 'mt-0.5 self-start',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
